



import { Component, Mixins, Prop } from "vue-property-decorator";
import { Department } from "../../../domain/department";
import { HisItemParameter } from "../../../domain/his/behavior";
import { IHisInfoSelectDialog } from "./IHisInfoSelectDialog";
import { IHisInformationGroupSource, HisInformationDepartmentGroupSource } from "../../../domain/his/groupInput/HisInformationGroupSource";
import DepartmentListSelectorDialog from "../../department/dialogs/DepartmentListSelectorDialog.vue";
import { IDepartmentListSelectorDialogCondition, IMultiDepartmentListSelectorDialogCondition } from "../../department/dialogs";

@Component({
  components: {
    DepartmentListSelectorDialog,
  },
})
export default class HisInfoDepartmentSelectDialog extends Mixins() implements IHisInfoSelectDialog {
  @Prop()
  parameter: HisItemParameter;

  @Prop()
  selectedItems: Department[];

  get hisInfoKey(): string {
    return this.parameter.key;
  }

  get isMultiSelect(): boolean {
    if (this.parameter == null) { return false; }

    return this.parameter.isMultiSelect;
  }

  async show(): Promise<IHisInformationGroupSource> {
    const departments =  await this.showDialog(this.isMultiSelect);

    return new HisInformationDepartmentGroupSource(departments);
  }

  private async showDialog(isMultiSelect: boolean): Promise<Department[]> {
    return (this.isMultiSelect)
      ? this.showMultiOrderableDepartmentSelectDialog()
      : this.showDepartmentSelectDialog();
  }

  private async showDepartmentSelectDialog(): Promise<Department[]> {
    const department = await this.$commonDialogs.department.listSelector.selectOptionConditionally(this.departmentSelectorDialogCondition);
    if (department === null) { return null; }
    if (department === undefined) { return undefined; }

    return [ department ];
  }

  private async showMultiOrderableDepartmentSelectDialog(): Promise<Department[]> {
    return this.$commonDialogs.department.multiOrderableListSelector.selectOptionsConditionally(this.multiDepartmentListSelectorDialogCondition, this.selectedItems);
  }

  get departmentSelectorDialogCondition(): IDepartmentListSelectorDialogCondition {
    return {
      name: this.$wording.common.department,
      nonDisplayDepartmentCodes: null,
      departmentGroup: this.$configuration.behavior.document.editor.departmentGroup.shouldIgnoreDepartmentGroupFilter ? null : undefined,
    };
  }

  get multiDepartmentListSelectorDialogCondition(): IMultiDepartmentListSelectorDialogCondition {
    return {
      name: this.$wording.common.department,
      nonDisplayDepartmentCodes: null,
      isMultiSelectable: false,
      departmentGroup: this.$configuration.behavior.document.editor.departmentGroup.shouldIgnoreDepartmentGroupFilter ? null : undefined,
    };
  }
}
